import config from '../../config/config';

import getRequest from './base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchPayments: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/wallet-history`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination version 2
   */
  fetchPaymentsV2: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.reportApiUrl}api/super-admin/v2/charging-transaction`, {
      ...parameters,
    });
  },
  /**
 * Fetch the Accounts list with pagination
 */
  fetchChargingSessionsListFilters: (data: QueryParameters = {}): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/charging-transaction/list-filters`, data),
  /**
   * Fetch charging sessions
   */
  fetchChargingSessions: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.reportApiUrl}api/super-admin/v2/charging-transaction/list-all-charging-transactions`, {
      ...parameters,
    });
  },
  /**
   * Fetch personal charging sessions
   */
  fetchPersonalChargingSessions: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.reportApiUrl}api/super-admin/v2/charging-transaction/list-all-personal-charging-transactions`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchPaymentsListFilters: (): Promise<any> =>
    getRequest(`${config.transactionApiUrl}api/super-admin/v1/wallet-history/list-filters`),

  /**
   * Fetch the Accounts list export
   */
  fetchPaymentsExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/wallet-history/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list export version 2
   */
  fetchPaymentsExportV2: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v2/charging-transaction/export-data`, {
      ...parameters,
    });
  },
};
